import React from 'react';
import PropTypes from 'prop-types';
import Logger from 'observability/Logger';

const LOG = new Logger('EventOps2-WithEventOpsAutoLoad');

const loadScript = (url) => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    script.defer = true;

    if (!__TESTING__) {
        document.body.appendChild(script);
    }
};

let loadStarted = false;

/**
 * @param {React} WrappedComponent
 * @return {React}
 */
export default function (WrappedComponent) {
    const WithEventOpsAutoLoad = (props) => {
        if (!loadStarted) {
            const url = props.widgetUrl;
            if (!url) {
                LOG.error(`EventOPS widget error. Invalid URL ${url}.`);
            } else {
                loadScript(url);
                loadStarted = true;
            }
        }
        return <WrappedComponent {...props} />;
    };

    WithEventOpsAutoLoad.propTypes = {
        widgetUrl: PropTypes.string.isRequired,
    };
    WithEventOpsAutoLoad.defaultProps = {};

    return WithEventOpsAutoLoad;
}

export const hasLoadStarted = () => loadStarted;
export const resetLoadStarted = () => {
    if (__TESTING__) {
        loadStarted = false;
    }
};
